export default __webpack_public_path__ + "static/media/video.cee375a0.svg";